// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1GB8p","title":"ClientInsurance_title__3H5q0","itemText":"ClientInsurance_itemText__17YKf"};